






































import { defineComponent } from '@vue/composition-api';
import { getI18nSettingsStore } from '@front-app/modules/i18n/store/i18nSettings';
import { PhoenixLocale } from '@front-app/modules/i18n/model/locale';
import { loadAndSetLocale } from '@front-app/modules/i18n/util/loaders';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import ScrollingColumn from '@front-app/components/layouts/columns/ScrollingColumn.vue';
import HelpTooltipBlock from '@front-app/components/dropdowns/HelpTooltipBlock.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormError from '@front-app/components/form/FormError.vue';
import LanguagePicker from '@front-app/components/inputs/LanguagePicker.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';

export default defineComponent({
	components: {
		ColumnContainer,
		ScrollingColumn,
		PaddedContent,
		SimpleCard,
		FormSection,
		FormLabel,
		FormError,
		LanguagePicker,
		HelpTooltipBlock,
		ColumnHeader,
	},
	setup(props, ctx) {
		const {
			getLocaleSetting,
			getDisplayLocale,
			setLocaleSetting,
		} = getI18nSettingsStore();
		const updateLanguage = async (newVal: PhoenixLocale) => {
			setLocaleSetting(newVal);
			await loadAndSetLocale(ctx.root.$i18n, getDisplayLocale());
		};
		return {
			updateLanguage,
			getLocaleSetting,
		};
	},
});
